import './MatchTimer.less';

import React, { FC } from 'react';
import { useScoreboardType } from '../matchExtras/useScoreboardType';
import { localizeMap } from '../utils';
import clsx from 'clsx';
import useMatchTimer from '../hooks/useMatchTimer';
import { formatTimer } from '../timer';
import { isMobileChannel } from '../../../common/util';

export const MatchTimer: FC<{
    scoreboardTypeId: string;
    matchTimer: any;
    otherClass?: string;
    shortTimeFormat?: boolean;
    mini?: boolean;
}> = ({ scoreboardTypeId, matchTimer, shortTimeFormat, otherClass, mini }) => {
    const scoreboardType = useScoreboardType(scoreboardTypeId);
    if (!matchTimer) {
        return null;
    }
    const showTimer = scoreboardType?.showTimer && matchTimer.get('clockVisible');
    const isFinished = () => matchTimer.get('status') === 'FINISHED';
    const hidePeriod = mini && isFinished();
    const period = hidePeriod ? '' : localizeMap(matchTimer.get('currentPeriod'));
    const timerFormat = shortTimeFormat ? "'mm" : scoreboardType?.timerFormat;
    return showTimer ? (
        <MatchTimerSeconds
            period={period}
            matchTimer={matchTimer}
            otherClass={otherClass}
            timerFormat={timerFormat}
            mini={mini}
        />
    ) : (
        period && (
            <div
                className={clsx(
                    'match-timer',
                    mini && !isMobileChannel() ? 'line-clamp-2 text-center' : 'ellipsis',
                    otherClass
                )}
                title={period}
                data-atid="match-timer"
            >
                {period}
            </div>
        )
    );
};

export const MatchTimerView: FC<{ timer?: string; clockStopped?: boolean; otherClass?: string }> = ({
    timer,
    clockStopped,
    otherClass
}) => (timer ? <span className={clsx(otherClass, { 'match-timer-stopped': clockStopped })}>{timer}</span> : null);

const MatchTimerSeconds: FC<{ period?; otherClass?: string; matchTimer; timerFormat: any; mini?: boolean }> = ({
    period,
    otherClass,
    matchTimer,
    timerFormat,
    mini
}) => {
    const clockStopped = matchTimer.get('clockStopped');
    const seconds = useMatchTimer(
        matchTimer.get('matchSeconds'),
        matchTimer.get('timestamp'),
        clockStopped,
        matchTimer.get('countDown')
    );
    const label = period + ' ' + formatTimer(seconds, timerFormat);
    const timer = formatTimer(seconds, timerFormat);
    const mobileChannel = isMobileChannel();
    return (
        <div
            className={clsx(
                'match-timer',
                mini && !mobileChannel ? 'flex-center' : 'flex ellipsis',
                { 'flex-col': mini && !mobileChannel, 'pt-3': mini && mobileChannel },
                otherClass
            )}
            title={label}
            data-atid="match-timer"
        >
            <span
                className={clsx(
                    mini && !mobileChannel ? 'line-clamp-2' : 'ellipsis',
                    { 'pr-5': !mini || mobileChannel },
                    { 'text-center': mini && !mobileChannel }
                )}
            >
                {period}
            </span>
            <MatchTimerView
                timer={timer}
                clockStopped={clockStopped}
                otherClass={clsx({ 'c-orange text-extra-bold': mini })}
            />
        </div>
    );
};
